import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-1 text-sm" }
const _hoisted_2 = { class: "font-semibold text-black-lp-300" }
const _hoisted_3 = { class: "text-black-lp-100 line-clamp-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    class: "p-3 bg-white",
    rounded: "xl",
    isShadow: false
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("bookingV3.goodsCategory")), 1),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.goodsNames), 1)
      ])
    ]),
    _: 1
  }))
}